export default __webpack_public_path__ + "static/media/delegate-deposit.2e4a6271.svg";